export const resumeContent =
    {
        jobHistory: [
            {
                company: "Cefinity",
                position: "Graphic and UI Designer",
                year: "August 2020 - January 2021",
                desc: "Provided both marketing and development team with high quality and UI designs for their upcoming web app that emphasizes both UX and look. During my tenure, I also helped the development team with front-end issues."        
            },
            {
                company: "For One Dream",
                position: "Senior Graphic and Web Designer",
                year: "June 2019 - August 2020",
                desc: "Planned and designed various design materials for clients, did professional grade photo retouching services based on their needs. Designed and developed single page RSVP mini-site for clients. Created a system that helped to improve the sales team efficiency by 10%."        
            },
            {
                company: "Express Bahari",
                position: "Web Designer and UI/UX Designer",
                year: "December 2018 - April 2019",
                desc: "Developed and redesigned the company's website that translated to 40% increase in user retention and 10% increase in conversion rate. I also designed their mobile app UI and helped declared a simple design identity."        
            },
            {
                company: "Revival ID / RevivalTV",
                position: "Senior Graphic Designer",
                year: "June 2013 - March 2017",
                desc: "Led rebranding initiative and project that resulted in 130% increase in social media engagement, prepared, designed various project proposals and company profile that resulted to various sponsorships by multiple prolific companies in Indonesia."        
            }
        ],
        education: [
            {
                uni: "義守大學 I-Shou University",
                year: "December 2017 - January 2019",
                desc: "Chinese Language"
            },
            {
                uni: "James Cook University Singapore",
                year: "March 2013 - August 2017",
                desc: "Bachelor of Information and Technology"
            }
        ],
        skillList:
            {
                design: ["Graphic Design", "Web Design", "UI Design", "Interaction Design", "Visual Design"],
                dev: ["HTML", "CSS", "SASS", "JavaScript", "React"],
                tool: ["Adobe Photoshop and Lightroom", "Adobe Illustrator", "Affinity Publisher", "Adobe Xd", "Figma", "Visual Studio Code"]
            }
    }